import { OverlayRef } from '@angular/cdk/overlay';
import { Subject, Observable } from 'rxjs';
import { OnCloseData } from './ap-dialog.service';

export class ApDialogRef<T> {

  private _afterClosed: Subject<OnCloseData<T>>;

  public get componentInstance(): T {
    return !!this.ref.component ? this.ref.component.instance : undefined;
  }

  constructor(public ref: OnCloseData<T>, private overlay: OverlayRef) { }

  close(): void {
    this.overlay.detach();
    this.overlay.dispose();
    if (this._afterClosed) {
      this._afterClosed.next(this.ref);
      this._afterClosed.complete();
    }
  }

  afterClosed(): Observable<OnCloseData<T>> {
    if (!this._afterClosed) {
      this._afterClosed = new Subject<T>();
    }
    return this._afterClosed.asObservable();
  }
}
